for (const e of document.querySelectorAll('.defaultFooter-title')) {
  e.addEventListener('click', () => {
    e.classList.toggle('is-expanded');
  });
}
